"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Divider = _styledComponents.default.hr(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  border-top: 0;\n  border-bottom: 1px solid ", ";\n"], ["\n  border-top: 0;\n  border-bottom: 1px solid ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.black;
});

var _default = Divider;
exports.default = _default;
var templateObject_1;